class QhRecesso {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.idQhPlano = dados ? dados.idQhPlano : null;
    this.data = dados ? dados.data : null;
    this.idTipoFuncao = dados ? dados.idTipoFuncao : null;
    this.descricao = dados ? dados.descricao : null;
  }

  static validations(required, maxLength) {
    return {
      data: { required },
      idTipoFuncao: { required },
      descricao: { required, maxLength: maxLength(50) }
    };
  }

  static validationMessages() {
    return {
      data: {
        required: "Data é obrigatória"
      },
      idTipoFuncao: {
        required: "Função é obrigatória"
      },
      descricao: {
        required: "Descrição é obrigatória",
        maxLength: "Descrição só aceita no máximo 50 caracteres"
      }
    };
  }
}
export default QhRecesso;
